@if (operation?.config) {
	<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
		<tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
			<tec-item
				[classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
				[tagImage]="{ icon: 'icon-AI' }"
				[clickeable]="false"
			>
				<tec-tag
					[label]="`WORKFLOWS.DETAIL.${operation?.config?.tutorial !== false ? 'ACTIVE' : 'INACTIVE'}` | translate"
					[status]="operation?.config?.tutorial !== false ? 'success' : 'disabled'"
				/>
			</tec-item>
		</tec-tile>

		<tec-tile
			[title]="'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_TITLE' | translate"
			[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_DESCRIPTION' | translate"
		>
			@if (!formSteps.length) {
				<p class="form-operation__empty">{{ 'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_EMPTY' | translate }}</p>
			}

			@for (step of formSteps; track stepTrackId(step)) {
				@let stepTags = getStepListTags(step);
				<tec-item
					[title]="stepTitle(step) || ('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.NEW_STEP' | translate)"
					[clickeable]="false"
					collapse
				>
					@if (stepTags.length) {
						<tec-tag-group [tags]="stepTags" />
					}
					<tec-list-detail>
						@if (resolvePresetTypeLabel(step)) {
							<span>{{ resolvePresetTypeLabel(step) }}</span>
						}
					</tec-list-detail>
					<span class="form-operation__step-order">{{
						'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.STEP_NUMBER' | translate: { order: stepOrder(step) }
					}}</span>

					@if (stepDescription(step)) {
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.DESCRIPTION' | translate">
							<span>{{ stepDescription(step) }}</span>
						</tec-info-group>
					}

					@if (stepFields(step).length) {
						<div class="form-operation__fields">
							@for (field of stepFields(step); track fieldTrackId(field)) {
								<tec-item
									[title]="fieldLabel(field)"
									[disabled]="true"
									[clickeable]="false"
									[classes]="['item--outline']"
								>
									<tec-list-detail>
										<span>{{ fieldTypeLabel(fieldType(field)) | translate }}</span>
									</tec-list-detail>
								</tec-item>
							}
						</div>
					}
				</tec-item>
			}
		</tec-tile>
	</tec-collapse>
}
